

window.addEventListener('load', function() {
  if(document.querySelector('.recharge-subscription-widget')) {
    const rechargeMain = document.querySelector('.recharge-subscription-widget');
    const rcWidget = rechargeMain.querySelector('div[data-v-app]');
    const labelWidget = document.createElement('p');
    labelWidget.classList.add('recharge-form__title');
    labelWidget.innerHTML = 'choose your frequency:';
    rechargeMain.insertBefore(labelWidget, rcWidget)
  }
  function change_atc() {

    if( document.querySelector('.product-form__submit-preorder') ) {
      document.querySelector('.product-form .product-form__submit span').textContent = 'Pre-order';
      return;
    }

    if( document.getElementById('rc-radio2').checked ){
      document.querySelector('.product-form .product-form__submit span').textContent = 'Add to cart';
      document.querySelector('input[name="properties[_rechargeOrder]').setAttribute("value", "true");

      var recharge_widget = document.querySelector('.rc-selling-plans');
      recharge_widget.innerHTML += "<ul class='recharge__features'><li>free shipping</li><li>gift and 2x points with every order</li><li>free 30-day returns</li><li>easy cancellations</li></ul>";

      // Monitor for change of selling plan
      var selling_plan_dropdown = document.querySelector('[name="rc_selling_plan"]');
      selling_plan_dropdown.addEventListener("change", function() {
        let selling_plan_id = selling_plan_dropdown.value;
        document.querySelector('.product-form-container [name="selling_plan"]').value = selling_plan_id;
      });

    } else { 
      document.querySelector('.product-form .product-form__submit span').textContent = 'Add to cart';
      document.querySelector('input[name="properties[_rechargeOrder]').setAttribute("value", "false");
    }

  }

  if( document.getElementById('rc-radio2') ) {
    change_atc();
  }

  // Monitor ReCharge radio buttons for change
  var recharge_radios = document.querySelectorAll('.rc-radio__input');  
  recharge_radios.forEach(radio => radio.addEventListener('change', () => change_atc()));

});